/* eslint-disable react/prop-types */
import {
  FormControl,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box
} from '@material-ui/core'
import { getConfigValue } from 'api'
import { isEmpty } from 'lodash'
import React from 'react'
import { get } from 'request'
import { sentryLogger } from 'sentry'

export const InventoryModalDropdown = ({
  value,
  batchId,
  handleOnChange,
  isCheckoutMode,
  errorSchema,
  label,
  options,
  name,
  configType
}) => {
  const [selectOptions, setSelectOptions] = React.useState([])

  const getOptions = async () => {
    const reasons = await getConfigValue({
      key: configType,
      app_name: 'alfred'
    })
    setSelectOptions(reasons)
  }

  React.useEffect(() => {
    if(configType) {
      getOptions()
    } else {
      setSelectOptions(options)
    }
  },[configType, options])

  const onChange = (e) => {
    handleOnChange(batchId, e.target.name, e.target.value)
  }

  return !isCheckoutMode ? (
    <FormControl
      variant="standard"
      size="small"
      {...(!isEmpty(errorSchema[name]) && errorSchema[name][batchId]
        ? { error: true }
        : null)}
      required>
      <InputLabel>{label}</InputLabel>
      <Select
        name={name}
        defaultValue={''}
        value={value}
        label={label}
        onChange={onChange}>
        {selectOptions?.map((val, index) => (
          <MenuItem key={index} value={val}>
            {val}
          </MenuItem>
        ))}
      </Select>
      {!isEmpty(errorSchema[name]) && errorSchema[name][batchId] && (
        <FormHelperText>{errorSchema[name][batchId]}</FormHelperText>
      )}
    </FormControl>
  ) : (
    <>
      {value !== undefined ? (
        <Typography variant="subtitle2">
          {`${label}: `}
          <Box display="inline" sx={{ fontWeight: 'bold' }}>
            {value}
          </Box>
        </Typography>
      ) : null}
    </>
  )
}
